<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1a"><a id="off-title1"></a><a id="page_xxxi">DEEP FREEZE</a></h1><a id="page_xxxi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// offtitle1.vue?58420840